import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=b6c1020a&scoped=true"
import script from "./OrderView.vue?vue&type=script&lang=js"
export * from "./OrderView.vue?vue&type=script&lang=js"
import style0 from "./OrderView.vue?vue&type=style&index=0&id=b6c1020a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c1020a",
  null
  
)

export default component.exports